import './bootstrap'

import LaravelPermissionToVueJS from "../../vendor/zodexnl/spatie-permission-to-vue-inertia/src/js";
import { createApp, h, nextTick } from "vue";
import { ZiggyVue } from 'ziggy';
import { createInertiaApp } from "@inertiajs/vue3";
import { usePage } from '@inertiajs/vue3'
import DynamicLayout from "./Pages/Layouts/DynamicLayout.vue";
import FlashMessage from "./Pages/Helper/FlashMessage.vue";
import VColCustom from "./Pages/Layouts/VCol.vue";
import VRowCustom from "./Pages/Layouts/VRow.vue";
import VFormCustom from "./Pages/Crud/VForm.vue";
import VViewCustom from "./Pages/Crud/VView.vue";


import "@fortawesome/fontawesome-free/css/all.css";

import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// PrimeVue 4.3+ - importy bez plików CSS tematów
// Tematy są teraz konfigurowane w JavaScript

import "../css/colors.css"
import "../css/images.css"
import "../css/auth.css";
import "../css/app.css";
import "../css/menu.css";
import "../css/view.css";
import "../css/form.css";
import "../css/helper.css";

import "../css/spinner.css";

import { createVuetify } from "vuetify";
import { VLayout } from "vuetify/components/VLayout";
import { VAppBar } from "vuetify/components/VAppBar";
import { VAppBarTitle } from "vuetify/components/VAppBar";
import { VApp } from "vuetify/components/VApp";
import { VImg } from "vuetify/components/VImg";
import { VList, VListItem } from "vuetify/components/VList";
import { VDivider } from "vuetify/components/VDivider";
import { VNavigationDrawer } from "vuetify/components/VNavigationDrawer";
import { VFooter } from "vuetify/components/VFooter";
import { VMain } from "vuetify/components/VMain";
import { VRow, VCol } from "vuetify/components/VGrid";

import PrimeVue from "primevue/config";
import { MyPreset } from "./primeVue/laraPreset.js";

import Tooltip from 'primevue/tooltip';
import '../css/tailwind.css';
import "../css/app.css";

import ToastService from 'primevue/toastservice';
import Ripple from 'primevue/ripple';

import { createPinia } from "pinia";

import { everyTimeCalledFunctions, onlyOnceCalledFunctions } from "./init.js";
//import { getAppName } from "@helper/utils.js";

const initApp = {
    install(app) {
        onlyOnceCalledFunctions();
    },
};

const pinia = createPinia();

const vuetify = createVuetify({
    components: {
        VLayout,
        VNavigationDrawer,
        VFooter,
        VMain,
        VRow,
        VCol,
        VAppBar,
        VAppBarTitle,
        VApp,
        VDivider,
        VList,
        VListItem,
        VImg,
    },
    directives: {
    },
    defaultTheme: 'light',
});

const startApp = () => {
    createInertiaApp({
        progress: {
            // The delay after which the progress bar will appear, in milliseconds...
            delay: 250,

            // The color of the progress bar...
            color: '#5851d8',

            // Whether to include the default NProgress styles...
            includeCSS: true,

            // Whether the NProgress spinner will be shown...
            showSpinner: true,
        },

        resolve: (name) => {
            const pages = import.meta.glob("./Pages/**/*.vue", { eager: true });
            const page = pages[`./Pages/${name}.vue`];

            // Sprawdź czy strona powinna mieć layout (menu)
            const pagesWithoutLayout = [
                'Auth/Login',
                'Auth/Register',
                'Auth/ForgotPassword',
                'Auth/ResetPassword',
                'Auth/VerifyEmail',
                'Errors/403',
                'Errors/404',
                'Errors/500'
            ];

            const shouldHaveLayout = !pagesWithoutLayout.includes(name);

            if (shouldHaveLayout) {
                // Użyj DynamicLayout, który automatycznie przełącza się między layoutami
                page.default.layout = page.default.layout || DynamicLayout;
            }

            return page;
        },

        title: (title) => {
            const page = usePage();
            return title ? title : page?.props?.appCaption;
        },

        setup({ el, App, props, plugin }) {
            const app = createApp({ render: () => h(App, props) });

            if (process.env.NODE_ENV === 'production') {
                app.config.devtools = false;
                app.config.productionTip = false;
            }

            app.mixin({
                created: everyTimeCalledFunctions,
                // methods: {
                //   can: LaravelPermissionToVueJS.can,
                // }
            });

            app.directive('focus', {
                mounted(el, binding) {
                    nextTick(() => {
                        if (binding.value) {
                            el.focus();
                        }
                    });
                },
            });
            app.directive('tooltip', Tooltip);
            app.directive('ripple', Ripple);

            app.config.globalProperties.$spinnerText = 'MarkeTHuB...';

            app.use(pinia)
                .use(initApp)
                .use(plugin)
                .use(ZiggyVue)
                .use(LaravelPermissionToVueJS)
                .use(vuetify)
                .use(PrimeVue, {
                    theme: {
                        preset: MyPreset,
                        options: {
                            prefix: 'p',
                            darkModeSelector: '.dark-mode',
                            cssLayer: false
                        }
                    },
                    inputVariant: "filled",
                    ripple: true,

                    pt: {
                    },
                })
                .use(ToastService)
                .component("flash-message", FlashMessage)
                .component("v-col", VColCustom)
                .component("v-row", VRowCustom)
                .component("v-form", VFormCustom)
                .component("v-view", VViewCustom)
                .mount(el);
        },
    });
}

startApp();

// Wykonaj żądanie "rozgrzewające" sesję
// await axios.get('/api/v1/session/init')
//     .then(() => {
//         const token = document.head.querySelector('meta[name="csrf-token"]');
//         if (token) {
//             axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
//         }

//         console.log('✅ Sesja pomyślnie zainicjalizowana. Uruchamiam aplikację...');
//         startApp(); // Uruchom aplikację dopiero po sukcesie
//     })
//     .catch(error => {
//         console.error('❌ Krytyczny błąd: Nie można zainicjalizować sesji. Sprawdź konfigurację serwera i tras.', error);
//         // Możesz tu wyświetlić komunikat błędu zamiast uruchamiać aplikację
//         document.body.innerHTML = '<div style="text-align: center; padding-top: 50px;"><h1>Błąd inicjalizacji aplikacji</h1><p>Nie można nawiązać połączenia z serwerem. Odśwież stronę lub skontaktuj się z administratorem.</p></div>';
//     });
